<div
  class="mgm-banner"
  [class.mgm-banner-minimized]="!isExpanded && canMinimize"
  [class.can-minimize]="canMinimize"
>
  <img [src]="imageSrc" alt="MGM Banner" />
  <div class="message">
    <h1 class="title">Convide um Profissional ou Estudante!</h1>
    <p class="subtitle desktop-subtitle" *ngIf="isExpanded">
      Traga seus companheiros de trabalho ou colegas estudantes para a maior e
      melhor plataforma de orientação.
    </p>
    <div class="bottom-row" *ngIf="isExpanded">
      <p class="subtitle mobile-subtitle">
        Traga seus companheiros de trabalho ou colegas estudantes para a maior e
        melhor plataforma de orientação.
      </p>
      <button
        class="button button-primary send-invite mobile-button"
        (click)="toggleModal()"
      >
        <i class="bi bi-envelope-fill" data-testid="send-invite-button"></i>
        <span>Enviar Convite</span>
      </button>
    </div>
    <button
      class="see-more"
      *ngIf="!isExpanded && canMinimize && !isMobile"
      (click)="toggleBanner()"
    >
      Ver Mais
    </button>
  </div>
  <button
    class="button button-primary send-invite desktop-button"
    *ngIf="isExpanded"
    (click)="toggleModal()"
  >
    <i class="bi bi-envelope-fill"></i>
    <span>Enviar Convite</span>
  </button>
  <button
    class="close-button"
    *ngIf="!isExpanded && canMinimize && isMobile"
    (click)="toggleBanner()"
  >
    Ver Mais
  </button>
  <button
    class="close-button"
    *ngIf="isExpanded && canMinimize"
    (click)="toggleBanner()"
  >
    Fechar
  </button>
</div>

<app-mgm-modal
  [openModal]="openModal"
  (closeModal)="toggleModal()"
></app-mgm-modal>
